import React from 'react';
import styled from 'styled-components';

type Props = {
  minDays?: number;
  maxDays?: number;
  hasLicensee: boolean;
};

const SendForPublishSuccessToast: React.FC<Props> = ({ minDays, maxDays, hasLicensee }) => (
  <div>
    <Title>Thank you for registering your EPD with the International EPD System!</Title>
    <Body>
      {hasLicensee ? (
        <>
          We will attend to it as soon as possible. We aim to publish the EPD within {minDays}-{maxDays} working days
          after the initial review by the Licensee. If you have any questions, feel free to contact the Secretariat at
          support@environdec.com.
        </>
      ) : (
        <>
          We will attend to it as soon as possible. We aim to publish the EPD within {minDays}-{maxDays} working days.
          If you have any questions feel free to contact the Secretariat at support@environdec.com.
        </>
      )}
    </Body>
    <Body>
      If any information is missing or if any irregularities are recognized in the submitted material, the Secretariat
      will contact you.
    </Body>
  </div>
);

export default SendForPublishSuccessToast;

const Title = styled.b`
  font-family: Inter;
  font-weight: 600;
  line-height: 20px;
`;

const Body = styled.p`
  font-family: Inter;
  font-weight: 400;
  line-height: 20px;
  opacity: 70%;
`;
